import {VAELTHAR_ID,vaeltharSkill} from '../../../../lib/character/src/vaelthar';
import {createVaeltharMind,vaeltharDecide,type VaeltharMind,type VaeltharPerception} from '../../../../lib/character/src/vaelthar-mind';
export const VAELTHAR_FIGHT_ID=VAELTHAR_ID;
export const VAELTHAR_FIGHT_KIT={
 style:'astral-space-controller',
 combo:['astral-thread','astral-thread','constellation-breaker','orbital-seal'],
 special:'orbital-seal',ultimate:'astral-cathedral',defense:'astrolabe-guard',evade:'star-step',
 rangeMeters:17,gravityLockDurationSec:1.8,gravitySlowMultiplier:.55,
 guardWindowSec:.42,parryWindowSec:.14,projectileRadiusMeters:.35,
} as const;
export type VaeltharFightAction={
 skillId:string;damage:number;radius:number;range:number;stunSeconds:number;slowMultiplier:number;manaCost:number;
};
/** Combat adapter. Engine applies damage through its normal authoritative hit resolution. */
export function resolveVaeltharFightAction(skillId:string,attackMultiplier=1):VaeltharFightAction|null{
 const skill=vaeltharSkill(skillId);
 if(!skill||!skill.gameplay.includes('fight'))return null;
 return {skillId,damage:Math.round(skill.power*Math.max(.1,attackMultiplier)*100)/100,
  radius:skill.areaMeters,range:skill.rangeMeters,
  stunSeconds:skill.effect==='gravity-bind'?VAELTHAR_FIGHT_KIT.gravityLockDurationSec:0,
  slowMultiplier:skill.effect==='gravity-bind'?VAELTHAR_FIGHT_KIT.gravitySlowMultiplier:1,manaCost:skill.manaCost};
}
export function stepVaeltharFightAI(state:VaeltharMind,perception:Omit<VaeltharPerception,'game'>){
 const result=vaeltharDecide(state,{...perception,game:'fight'});
 return {...result,action:result.decision.skillId?resolveVaeltharFightAction(result.decision.skillId):null};
}
/** Apply genuine, bounded Orbital Seal gravity to the game's authoritative combatant. */
export function applyVaeltharGravityOnContact<T extends {gravityBindTimer?:number;gravitySlowMultiplier?:number}>(
 attackerId:string,kind:string|null,impact:string,defender:T):T{
 if(attackerId!==VAELTHAR_ID||kind!=='special'||impact!=='hit')return defender;
 const spell=resolveVaeltharFightAction('orbital-seal');
 if(!spell)return defender;
 return {...defender,gravityBindTimer:Math.max(defender.gravityBindTimer??0,spell.stunSeconds),
  gravitySlowMultiplier:Math.min(defender.gravitySlowMultiplier??1,spell.slowMultiplier)};
}
export const newVaeltharFightAI=()=>createVaeltharMind();

